﻿/* eslint unicorn/filename-case: 0 sonarjs/no-identical-functions: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cIf from 'classnames';
import createClass from 'create-react-class';
import { CART_DISPLAY_BYNAME } from '../src/components/molecules/cartstatus/views';

//Uses window.tsapp
const AjaxStateFeeder = require("ts-util").AjaxStateFeeder;
const tsRest = require("ts-rest-client");
const moment = require("moment");
const _ = require("lodash");
const tr = require('ts-translate-js').default.boundTR;
const trN = tr;


const CART_DISPLAY_NAME_BY_INTEGNAME = {
    rese: "DISPLAY_RESE",
    sam: "DISPLAY_SAM",
    villealmaspectacle: "DISPLAY_VILLEALMASPECTACLE",
    ror: "DISPLAY_ROR",
    osl: "DISPLAY_VILLEALMASPECTACLE",
    oslfch: "DISPLAY_DEFAULTCARTPREVIEW",
    lecalypso: "DISPLAY_LECALYPSO",
    lesaiglestr: "DISPLAY_LESAIGLESTR",
    bieresdumonde: "DISPLAY_BIERESDUMONDE",
    festivalgrandeourse: "DISPLAY_DEFAULTCARTPREVIEW",
    festibierecharlevoix: "DISPLAY_DEFAULTCARTPREVIEW",
    rythmesdumonde: "DISPLAY_DEFAULTCARTPREVIEW",
    productionshakim: "DISPLAY_DEFAULTCARTPREVIEW",
    lvlup: "DISPLAY_LVLUP",
    lgrdm: "DISPLAY_DEFAULTCARTPREVIEW",
        tmc: "DISPLAY_DEFAULTCARTPREVIEW"
};
const DEFAULT_CART_DISPLAY_NAME = "DISPLAY1";

export class CartHorizontalStatusWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loginStatus: this.props.loginStatus, // That way because this cart auto-refresh it-self. We want that control to be as standalone as possible. If you don't want this then create a sub control!
            cartStatus: this.props.cartStatus, // That way because this cart auto-refresh it-self. We want that control to be as standalone as possible. If you don't want this then create a sub control!
            serverTimeDiff: null // Add this to your browser date to match the server
        };

        this.goToCart = this.goToCart.bind(this);
        this.handleLogoutClick = this.handleLogoutClick.bind(this);
        this.handleCartRefresh =  this.handleCartRefresh.bind(this);
    }

    componentDidMount() {
        //RCOMBRIDGE_copyTrackingCookies();

        if (!this.props.isInMaintenance) {
            if(this.props.registerRefreshHandler) this.props.registerRefreshHandler(this.handleCartRefresh);
            if(this.props.loginStatus == null || this.props.cartstatus == null) this.handleCartRefresh();

            if(this.props.cartstatus !== undefined)
                this.state.serverTimeDiff = this.getServerTimeDiff(this.props.cartstatus);

            this.displayTime = true;

            this.timerInterval = setInterval(function(){ this.forceUpdate(); }.bind(this), 1000);
        }
        
        this.raiseContentChanged();
    }

    componentDidUpdate () {
        this.raiseContentChanged();
    }

    componentWillUnmount () {
        this.props.refreshHandler.onCartRefresh = null;
        if(this.props.unregisterRefreshHandler) this.props.unregisterRefreshHandler(this.handleCartRefresh);
        if(this.cartStatusRequest != null) this.cartStatusRequest.abort();

        clearInterval(this.timerInterval);
    }

    getServerTimeDiff(cartStatus) {
        return moment(cartStatus.serverTimeUTC).diff(moment.utc())
    }

    handleCartRefresh() {
        this.cartStatusRequest = tsapp.mvcapi.postCtl("cart/cartstatus", null, { cache: false })
                                        .success(function(data) {
                                            this.setState({
                                                loginStatus: data.loginStatus,
                                                cartStatus: data.cartStatus
                                            }, function() {
                                                this.getServerTimeDiff(data.cartStatus);
                                            });
                                            // console.log("Cart refreshed!");
                                        }.bind(this));
    }

    /*
    handleViewCartClick() {
        this.cartStatusRequest = tsapp.mvcapi.postCtl("cart/Cart")
                                        .success(function() {
                                            this.goToCart();
                                        }.bind(this));
    },
    */
    
    goToCart() {
        tsapp.goToCart(this.props.integ);
    }

    goToHome() {
        tsapp.goToHome(this.props.integ);
    }

    handleLogoutClick(e) {
        e.preventDefault();
        this.cartStatusRequest = tsapp.mvcapi.postCtl("login/logout", null, { cache: false })
                                        .success(function() {
                                            this.goToHome();
                                        }.bind(this));
    }

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    }

    render(){
        const ready = this.state.cartStatus != null;

        let productCount;
        let userIsConnected;

        if(this.state.cartStatus)
            productCount = this.state.cartStatus.ticketCount;

        if(this.state.loginStatus)
            userIsConnected = this.state.loginStatus.isAuthenticated;

        let cartIsExpired = false;
        let timeString = null;

        let expiresSoon = false;
        if(productCount > 0) {

            // Get computer time
            const computerUTC = moment.utc();
            const currentTimeMatched = moment.utc().add(this.state.serverTimeDiff, "ms"); // Time matched to server time. This is for computers that have a big difference with the server time

            // Get expiry date
            const expiryDateUTC = moment.utc(this.state.cartStatus.expiryDateUTC);

            // Get the diff!
            const remainingTimeMS = expiryDateUTC.diff(currentTimeMatched);

            if(remainingTimeMS <= (3 * 60 * 1000)) {
                this.displayTime = !this.displayTime;
                expiresSoon = true;
            }

            if(remainingTimeMS > 0)
                timeString = moment.utc(remainingTimeMS).format("m:ss"); // Build the time string
            else {
                productCount = 0;
                cartIsExpired = true; // So we suppose that there are no tickets in the cart anymore...
            }
        }

        const displayName = this.props.cartDisplayName || CART_DISPLAY_NAME_BY_INTEGNAME[this.props.integ] || DEFAULT_CART_DISPLAY_NAME;
        const View = CART_DISPLAY_BYNAME[displayName];

        return (
            <View
                ready={ready}
                onCartClick={this.goToCart}
                cartExpired={cartIsExpired}
                productCount={productCount}
                remainingTimeString={timeString}
                expiresSoon={expiresSoon}
                displayTime={this.displayTime}
                showLogout={userIsConnected}
                onLogoutClick={this.handleLogoutClick}
            />
        );
    }
}

CartHorizontalStatusWidget.propTypes = {
    loginStatus: PropTypes.shape({
        isAuthenticated: PropTypes.bool,
        firstName: PropTypes.string,
        lastName: PropTypes.string
    }),
    cartStatus: PropTypes.shape({ // Default preloaded cart status!
        ticketCount: PropTypes.number,
        expiryDateUTC: PropTypes.string,
        serverTimeUTC: PropTypes.string
    }),
    integ: PropTypes.string,
    onContentChange: PropTypes.func,
    registerRefreshHandler: PropTypes.func,
    unregisterRefreshHandler: PropTypes.func,
    cartDisplayName: PropTypes.string,
    isInMaintenance: PropTypes.bool
};

